<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-select
          v-model="v.code.$model"
          :errorMessages="getValidationErrorText(v.code)"
          :items="documents"
          item-value="code"
          item-text="title"
          label="Тип документа"
          @change="changeCode"
          outlined
          :disabled="disabled"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Серия документа"
          outlined
          v-model="v.series.$model"
          :errorMessages="getValidationErrorText(v.series)"
          v-mask="token.series"
          :disabled="
            isMrpa
              ? v.mrpDisabled.$model.includes(FieldName.DOCUMENT_SERIES)
              : disabled
          "
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">{{ mdiHelpCircle }}</v-icon>
              </template>
              <Hint>
                <template v-slot:text>
                  <div>
                    Необходимо указать серию документа в формате:
                    {{ token.series.mask }}
                  </div>
                </template>
                <template v-slot:body>
                  <ul style="margin-left: 30px; margin-top: 5px">
                    <li
                      v-for="(item, index) in hints(token.series.mask)"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </template>
              </Hint>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Номер документа"
          outlined
          v-model="v.number.$model"
          :errorMessages="getValidationErrorText(v.number)"
          v-mask="token.number"
          :disabled="disabled"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">{{ mdiHelpCircle }}</v-icon>
              </template>
              <Hint>
                <template v-slot:text>
                  <div>
                    Необходимо указать номер документа в формате:
                    {{ token.number.mask }}
                  </div>
                </template>
                <template v-slot:body>
                  <ul style="margin-left: 30px; margin-top: 5px">
                    <li
                      v-for="(item, index) in hints(token.number.mask)"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </template>
              </Hint>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiHelpCircle } from '@mdi/js';
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators';

import Hint from '@/components/base/Hint';
import hints from '@/utils/mask';
import { getIdentityDocumentToken, RUS_PASSPORT } from '@/utils/services';
import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { FieldName } from '@/constants';

export const identityDocumentModel = {
  code: RUS_PASSPORT,
  series: '',
  number: '',
  mrpDisabled: [],
};

export const identityDocumentValidation = {
  code: {
    required,
  },
  series: {
    required: requiredIf(function (value) {
      return value.code === RUS_PASSPORT;
    }),
    maxLength: maxLength(25),
    EMOJI,
  },
  number: {
    required,
    maxLength: maxLength(25),
    EMOJI,
  },
  mrpDisabled: {},
};

export default {
  name: 'IdentityDocument',
  props: {
    v: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    documents: {
      type: Array,
      required: true,
    },
    isMrpa: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Hint,
  },
  data: () => ({
    FieldName,
    hints,
    mdiHelpCircle,
    getValidationErrorText,
  }),

  computed: {
    token() {
      return getIdentityDocumentToken(this.v.code.$model);
    },
  },

  methods: {
    changeCode() {
      this.reset();
      this.v.$reset();
    },

    reset() {
      this.v.series.$model = '';
      this.v.number.$model = '';
    },
  },
};
</script>
